"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_CONFIG = void 0;
var _auth = require("@ori/auth");
// This can be extended by specific types for your Online properties

const DEFAULT_CONFIG = exports.DEFAULT_CONFIG = {
  customerId: _auth.NOT_LOGGED_IN_USER_ID,
  customerOrdersLink: '/mypages/order/customer-orders',
  defaultQty: 1,
  isBackorderExplicit: false,
  isDoubleCurrency: false,
  isQofVisible: false,
  isSimplifiedCheckout: false,
  manageSubscriptionLink: '/mypages/order/manage-subscriptions',
  maxValue: 99,
  minValue: 1,
  periodId: 0,
  rewardsShopLink: '/oriflame-rewards'
};